var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgF(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "158px",
    height: "310px",
    viewBox: "0 0 158 310",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "f") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f",
    fill: "#5B4359",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.703,165.106 L39.684,165.106 L39.684,305 C39.684,307.762 41.922,310 44.684,310 L102.3,310 C105.062,310 107.3,307.762 107.3,305 L107.3,165.765 L146.364,165.765 C148.904,165.765 151.041,163.859 151.331,161.336 L157.264,109.834 C157.427,108.417 156.978,106.998 156.03,105.935 C155.081,104.871 153.723,104.262 152.298,104.262 L107.302,104.262 L107.302,71.978 C107.302,62.246 112.542,57.311 122.878,57.311 C124.351,57.311 152.298,57.311 152.298,57.311 C155.06,57.311 157.298,55.072 157.298,52.311 L157.298,5.037 C157.298,2.275 155.06,0.037 152.298,0.037 L111.753,0.037 C111.467,0.023 110.832,0 109.896,0 C102.861,0 78.408,1.381 59.092,19.151 C37.69,38.843 40.665,62.421 41.376,66.509 L41.376,104.261 L5.703,104.261 C2.941,104.261 0.703,106.499 0.703,109.261 L0.703,160.105 C0.703,162.867 2.941,165.106 5.703,165.106 Z",
    id: "XMLID_835_"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF);
export default __webpack_public_path__ + "static/media/f.444cf3a32dcf23c26f64b8e8880c4929.svg";
export { ForwardRef as ReactComponent };